import config from '../../config'

import { IGetGetRequest } from '../../interfaces'

const getInspectionTypeByIdQueryRequest: IGetGetRequest = params => {
  const { airportId, id } = params

  return {
    method: 'get',
    url: `${config.baseUrl}/${airportId}/InspectionTypes/${id}`,
  }
}

export default getInspectionTypeByIdQueryRequest
